import { render, staticRenderFns } from "./OpportunityKanbanCard.vue?vue&type=template&id=ecec5b56&scoped=true&"
import script from "./OpportunityKanbanCard.vue?vue&type=script&lang=js&"
export * from "./OpportunityKanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityKanbanCard.vue?vue&type=style&index=0&id=ecec5b56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecec5b56",
  null
  
)

export default component.exports